module.exports = __webpack_public_path__ + "img/a75f669c97481895bb290283a3e3fa13.png";